// extracted by mini-css-extract-plugin
module.exports = {"container":"container___3AKJN","icon":"icon___1RU5d","text":"text___30l2n"};